"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    title1ClassNames: function() {
        return title1ClassNames;
    },
    useTitle1Styles: function() {
        return useTitle1Styles;
    }
});
const _react = require("@griffel/react");
const title1ClassNames = {
    root: 'fui-Title1'
};
const useTitle1Styles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fccw675",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "f1ebx5kk"
    }
}, {
    d: [
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fccw675{font-size:var(--fontSizeHero800);}",
        ".fl43uef{font-weight:var(--fontWeightSemibold);}",
        ".f1ebx5kk{line-height:var(--lineHeightHero800);}"
    ]
});
